import {Award, EyeOff, HeartHandshake, ShieldCheck} from 'lucide-react'
import FadeIn from '@/components/FadeIn'

const reasons = [
  {
    icon: Award,
    title: 'Anos de experiência',
    description: 'Trajetória consolidada no mercado digital, com profundo conhecimento de projetos e audiências online.',
  },
  {
    icon: HeartHandshake,
    title: 'Atendimento personalizado',
    description: 'Cada negociação é conduzida de forma próxima, entendendo as necessidades específicas de cada parte.',
  },
  {
    icon: EyeOff,
    title: 'Sigilo absoluto',
    description: 'Confidencialidade em todas as etapas, protegendo informações sensíveis de compradores e vendedores.',
  },
  {
    icon: ShieldCheck,
    title: 'Segurança na negociação',
    description: 'Processos estruturados que reduzem riscos e garantem tranquilidade do início ao fim da operação.',
  },
]

function WhyChooseUs() {
  return (
    <section className="py-16 sm:py-20 bg-blue-950 text-white">
      <div className="max-w-6xl mx-auto px-6 sm:px-8">
        <FadeIn className="max-w-2xl">
          <span className="text-xs font-semibold tracking-widest text-white/60 uppercase">Diferenciais</span>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight">
            Por que escolher a Muita Mídia
          </h2>
        </FadeIn>
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-4">
          {reasons.map((reason, index) => (
            <FadeIn key={reason.title} delay={index * 80}>
              <div className="group h-full rounded-2xl bg-white p-6 sm:p-7 shadow-lg shadow-black/10 border border-transparent transition-all duration-300 hover:-translate-y-1.5 hover:shadow-2xl hover:shadow-blue-500/20 hover:border-blue-400/40">
                <div className="flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br from-blue-600 to-blue-900 shadow-md shadow-blue-600/30">
                  <reason.icon className="w-5 h-5 text-white" strokeWidth={1.5} />
                </div>
                <h3 className="mt-4 text-lg font-semibold tracking-tight text-slate-950">
                  {reason.title}
                </h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">
                  {reason.description}
                </p>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  )
}

export default WhyChooseUs
